import {
  LuAppWindow,
  LuArrowLeft,
  LuArrowRight,
  LuArrowUpRight,
  LuBell,
  LuBookText,
  LuBot,
  LuBraces,
  LuCheck,
  LuChevronDown,
  LuChevronLeft,
  LuChevronRight,
  LuCircleAlert,
  LuCircleCheck,
  LuCircleX,
  LuClock,
  LuCloudCog,
  LuCloudUpload,
  LuCode,
  LuCopy,
  LuCpu,
  LuDownload,
  LuEllipsis,
  LuExternalLink,
  LuEye,
  LuFile,
  LuFileArchive,
  LuFilter,
  LuFlaskConical,
  LuGitBranch,
  LuGlobe,
  LuHistory,
  LuImage,
  LuInfo,
  LuLandmark,
  LuLaptop,
  LuLightbulb,
  LuLink,
  LuLock,
  LuLockOpen,
  LuLogOut,
  LuMenu,
  LuPencil,
  LuPlay,
  LuPlus,
  LuRefreshCw,
  LuRotateCcw,
  LuSearch,
  LuSearchCheck,
  LuSend,
  LuSettings,
  LuSettings2,
  LuShare2,
  LuShieldAlert,
  LuShieldCheck,
  LuShieldX,
  LuSparkles,
  LuStar,
  LuTag,
  LuTrash2,
  LuTriangleAlert,
  LuUndo2,
  LuUpload,
  LuUser,
  LuUsers,
  LuWebhook,
  LuX,
} from 'react-icons/lu';

/**
 * Dict of react-icons used in the project.
 *
 * Re-export allows code completion and documentation.
 *
 * Browse bundled icons: @see http://localhost:9000/dev/icons
 *
 * ```tsx
 * import { icons } from '@/assets/icons';
 *
 * <Icon size="lg" color="tomato">
 *   <Icon.LuClipboardList />
 *   //    ^ ...leverage auto-complete
 * </Icon>
 * ```
 *
 * @see https://chakra-ui.com/docs/components/icon#react-icons
 */
export const Icons = {
  LuAppWindow,
  LuArrowLeft,
  LuArrowRight,
  LuArrowUpRight,
  LuBell,
  LuBookText,
  LuBot,
  LuBraces,
  LuCheck,
  LuChevronDown,
  LuChevronLeft,
  LuChevronRight,
  LuCircleAlert,
  LuCircleCheck,
  LuCircleX,
  LuClock,
  LuCloudCog,
  LuCloudUpload,
  LuCode,
  LuCopy,
  LuCpu,
  LuDownload,
  LuEllipsis,
  LuExternalLink,
  LuEye,
  LuFile,
  LuFileArchive,
  LuFilter,
  LuFlaskConical,
  LuGitBranch,
  LuGlobe,
  LuHistory,
  LuImage,
  LuInfo,
  LuLandmark,
  LuLaptop,
  LuLightbulb,
  LuLink,
  LuLock,
  LuLockOpen,
  LuLogOut,
  LuMenu,
  LuPencil,
  LuPlay,
  LuPlus,
  LuRefreshCw,
  LuRotateCcw,
  LuSearch,
  LuSearchCheck,
  LuSend,
  LuSettings,
  LuSettings2,
  LuShare2,
  LuShieldAlert,
  LuShieldCheck,
  LuShieldX,
  LuSparkles,
  LuStar,
  LuTag,
  LuTrash2,
  LuTriangleAlert,
  LuUndo2,
  LuUpload,
  LuUser,
  LuUsers,
  LuWebhook,
  LuX,
};
